/** Drawing-buffer limits in CSS pixels and device scale. The supplied sample
 * lists must cover both HDR color and depth formats; unsupported MSAA uses zero.
 * Coarse-pointer devices use a one-million-pixel/1.5-DPR budget and at most2
 * common MSAA samples, retaining smooth edges with bounded HDR raster cost.
 * bloomScale reduces only the bloom mip chain, preserving crisp scene/HUD.
 * These capability budgets are not measurements of available GPU memory. */
export function skyRenderQuality(
  width,
  height,
  dpr,
  colorSamples = [],
  depthSamples = [],
  { coarsePointer = false } = {},
) {
  const w = Math.max(1, width),
    h = Math.max(1, height);
  return {
    ratio: Math.min(
      Math.max(1, dpr || 1),
      coarsePointer ? 1.5 : 2,
      Math.sqrt((coarsePointer ? 1000000 : 2000000) / (w * h)),
      4096 / Math.max(w, h),
    ),
    samples: Math.max(
      0,
      ...Array.from(colorSamples).filter(
        (n) => n <= (coarsePointer ? 2 : 4) && n > 0 && Array.from(depthSamples).includes(n),
      ),
    ),
    bloomScale: coarsePointer ? 0.5 : 1,
  };
}
